import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../i18n/useTranslation';
import './Footer.css';

const Footer = () => {
  const { t, phone } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <span className="footer__logo-icon">🔧</span>
              <div>
                <span className="footer__logo-name">{t('brand.name')}</span>
                <span className="footer__logo-desc">{t('brand.desc')}</span>
              </div>
            </Link>
            <p className="footer__about">{t('footer.about')}</p>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">{t('footer.servicesTitle')}</h4>
            <ul className="footer__links">
              <li><Link to="/" state={{ priceSlug: 'segserdi-onoshilgoo' }}>{t('footer.svcDiag')}</Link></li>
              <li><Link to="/" state={{ priceSlug: 'kompyuter-onoshilgoo' }}>{t('footer.svcComputer')}</Link></li>
              <li><Link to="/" state={{ priceSlug: 'duguyn-balance-tohirgoo' }}>{t('footer.svcBalance')}</Link></li>
              <li><Link to="/" state={{ priceSlug: 'tenkhleg-tohirgoo' }}>{t('footer.svcAlignment')}</Link></li>
              <li><Link to="/" state={{ priceSlug: 'motor-tos-solikh' }}>{t('footer.svcOil')}</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">{t('footer.infoTitle')}</h4>
            <ul className="footer__links">
              <li><a href="#about">{t('footer.aboutCompany')}</a></li>
              <li><a href="#prices">{t('nav.prices')}</a></li>
              <li><a href="#contacts">{t('nav.contacts')}</a></li>
              <li><a href="#">{t('footer.privacyPolicy')}</a></li>
            </ul>
          </div>

          <div className="footer__col">
            <h4 className="footer__heading">{t('footer.contactsTitle')}</h4>
            <ul className="footer__contacts">
              <li>📞 <a href={`tel:${phone.replace(/\s/g, '')}`}>{phone}</a></li>
              <li>✉️ <a href="mailto:powerautoservice.99@gmail.com">powerautoservice.99@gmail.com</a></li>
              <li>📍 {t('contacts.addressValue')}</li>
              <li>🕐 {t('contacts.weekdays')}</li>
              <li>🌙 {t('contacts.nightSurcharge')}</li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© {currentYear} {t('brand.name')}. {t('footer.copyright')}</p>
          <p>{t('footer.disclaimer')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
